import { Component, Injector, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

interface ConfirmationDrawerData {
  title?: string;
  imageUrl?: string;
  html?: string;
  showCancelButton?: boolean;
  cancelButtonText?: string;
  confirmButtonText?: string;
  onDiscard?: () => void;
  onConfirm?: () => void;
}

@Component({
  selector: 'app-confirmation-drawer',
  templateUrl: './confirmation-drawer.component.html',
  styleUrls: ['./confirmation-drawer.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class ConfirmationDrawerComponent implements OnInit {
  htmlDirection: string;
  data: ConfirmationDrawerData;

  constructor(private injector: Injector) {}

  private get dialogRef(): MatDialogRef<ConfirmationDrawerComponent> | null {
    try {
      return this.injector.get(MatDialogRef);
    } catch {
      return null;
    }
  }

  ngOnInit(): void {
    this.htmlDirection = localStorage.getItem('html-dir') || 'ltr';
    try {
      const dialogData = this.injector.get(
        MAT_DIALOG_DATA,
      ) as ConfirmationDrawerData;
      if (dialogData) {
        this.data = dialogData;
      }
    } catch {}
  }

  close() {
    this.data?.onDiscard();
    this.dialogRef?.close();
  }

  confirm() {
    this.data?.onConfirm();
    this.dialogRef?.close();
  }
}
